import { IconVolume, IconVolumeOff } from "@tabler/icons-react";
import ReactRangeSliderInput from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import { DeviceSelect } from "./device-select/device-select";
import s from "./conference-settings-modal.module.scss";

export { DeviceSelect };


export const VolumeSlider = ({ label, value, onChange, min = 0, max = 100 }) => {
  return (
    <label className={s.volumeField}>
      <span className={s.fieldLabel}>{label}</span>
      <div className={s.volumeRow}>
        <span className={s.volumeIcon} aria-hidden="true">
          {value === min ? <IconVolumeOff size={22} /> : <IconVolume size={22} />}
        </span>
        <ReactRangeSliderInput
          className={s.volumeSlider}
          rangeSlideDisabled={true}
          min={min}
          max={max}
          step="1"
          thumbsDisabled={[true, false]}
          value={[min, value]}
          onInput={(nextValue) => onChange(nextValue[1])}
        />
      </div>
    </label>
  );
};

export const SelectRow = ({ label, caption, value, options, onChange, sectionClassName = "" }) => {
  return (
    <div className={`${s.settingRow} ${sectionClassName}`.trim()}>
      <div className={s.settingMeta}>
        <div className={s.settingLabel}>{label}</div>
        {caption ? <div className={s.settingCaption}>{caption}</div> : null}
      </div>
      <select className={s.select} value={value} onChange={(event) => onChange(event.target.value)}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
